export default {
  getChecklistTransaction: (state) => state.checklistTransaction,
};
